// Dependencies
import $ from 'jquery';
import ListItem from './connections-list-item';
import { Link } from 'react-router';
import React, { createClass, PropTypes } from 'react';
import Pagination from '../tc-ui/pagination/pagination';

const List = createClass({
  propTypes: {
    connections: PropTypes.object,
    loadMoreConnections: PropTypes.func,
    connectionsStats: PropTypes.object,
    routeName: PropTypes.string,
    isSearching: PropTypes.bool,
    tags: PropTypes.array,
  },

  componentDidMount() {
    // if (window.addEventListener) {
    //   window.addEventListener('scroll', this.onScroll, false);
    // } else {
    //   window.attachEvent('onscroll', this.onScroll);
    // }
  },

  componentWillUnmount() {
    // if (window.addEventListener) {
    //   window.removeEventListener('scroll', this.onScroll, false);
    // } else {
    //   window.detachEvent('onScroll', this.onScroll);
    // }
  },

  onScroll() {
    const { connections, loadMoreConnections } = this.props;
    const scrollTop = document.body.scrollTop || $('html').scrollTop(); // Firefox doc.body.scrollTop always 0 - so must switch to jquery html
    if (
      document.body.offsetHeight + scrollTop === document.body.scrollHeight &&
      connections.nextPage
    ) {
      loadMoreConnections(this.props.connections.nextPage);
    }
  },

  render() {
    const { connections } = this.props;
    const totalPages = Math.ceil(connections.resultCount / 20);
    let listItems = connections.items.map((connection, index) => (
      <ListItem
        {...this.props}
        {...connection}
        connectionId={connection.id}
        allUserTags={this.props.tags}
        key={index}
      />
    ));

    let containerClass;
    let message;
    let itemsCount;

    const links = (
      <span>
        Add new connections <Link to="/connections/add-connections">here</Link> or search for new
        partners <Link to="/partner-finder/results">here</Link>.
      </span>
    );

    switch (this.props.routeName) {
      case 'requests':
        itemsCount = this.props.connectionsStats.pendingRequestCount;
        if (!itemsCount) {
          message = 'You have no new connection requests.';
        }
        break;
      case 'invites':
        itemsCount = this.props.connectionsStats.pendingInviteCount;
        if (!itemsCount) {
          message = <span>You have no pending connections. {links}</span>;
        }
        break;
      case 'connected':
      default:
        itemsCount = this.props.connectionsStats.totalCount;
        if (!itemsCount) {
          message = <span>You have no connections. {links}</span>;
        }
        break;
    }

    if (message) {
      containerClass = 'no-connections';
      listItems = <h4 className="no-connections-message">{message}</h4>;
    } else if (!listItems.length) {
      if (
        !this.props.isSearching &&
        (this.props.connections.searchString || this.props.connections.filteredCountries)
      ) {
        containerClass = 'no-connections';
        listItems = (
          <h4 className="no-connections-message"> We did not find any results for your search.</h4>
        );
      } else {
        containerClass = 'no-connections-loading';
        listItems = <div className="no-connections" />;
      }
    } else {
      containerClass = 'connections-list';
    }

    return (
      <div onScroll={this.onScroll} className={containerClass}>
        {listItems}
        {totalPages > 1 && this.props.filter ? (
          <Pagination
            currentPage={connections.page}
            totalPages={totalPages}
            goToPage={this.props.loadMoreConnections}
            noOfPagesToShow={5}
          />
        ) : (
          <span />
        )}
      </div>
    );
  },
});

export default List;

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-list.jsx